import { COMPONENT_TYPES } from '../../../constants';
import { registerSkinnableComponent } from '../registry';
import { SignupSkinnable } from './SignupSkinnable';

// Register Signup as a skinnable component
registerSkinnableComponent(SignupSkinnable);

// Export for backward compatibility
export { default as SignupComponent } from './Signup.component';
export { default as SignupEditor } from './Signup.editor';
export { default as SignupProperties } from './Signup.properties';
export * from './Signup.types';
export { SignupSkinnable }; 